<form [formGroup]="composeForm">

    <!-- Subject -->
    <ms-input-label [isRequired]="isFieldRequired(composeForm, 'subject')" [labelText]="'Subject'" />
    <input
        type="text"
        id="subject"
        formControlName="subject"
        [required]="isFieldRequired(composeForm, 'subject')"
        maxlength="150"
        class="form-control"
        [class.is-invalid]="composeForm.get('subject')?.invalid && composeForm.get('subject')?.touched"
        [class.is-valid]="composeForm.get('subject')?.valid && composeForm.get('subject')?.touched" />
    @if (composeForm.get('subject')?.invalid && composeForm.get('subject')?.touched) {
        <div class="error-messages">
            @if (composeForm.get('subject')?.errors?.['required']) {
                <p class="text-danger text-start pt-1 mb-0">{{ FormValidatorMessages.CommunicationsSubjectRequired }}</p>
            }
            @if (composeForm.get('subject')?.errors?.['maxlength']) {
                <p class="text-danger text-start pt-1 mb-0">{{ FormValidatorMessages.CommunicationsSubjectMaxLength }}</p>
            }
        </div>
    }

    <!-- Body -->
    <ms-input-label [isRequired]="isFieldRequired(composeForm, 'body')" [labelText]="'Message'" class="mt-3" />
    <ms-rich-text-editor
        formControlName="body"
        [required]="isFieldRequired(composeForm, 'body')">
    </ms-rich-text-editor>
    @if (composeForm.get('body')?.invalid && composeForm.get('body')?.touched) {
        <div class="error-messages">
            @if (composeForm.get('body')?.errors?.['required']) {
                <p class="text-danger text-start pt-1 mb-0">{{ FormValidatorMessages.CommunicationsBodyRequired }}</p>
            }
        </div>
    }

    <!-- Footer -->
    <ms-input-label [isRequired]="isFieldRequired(composeForm, 'footer')" [labelText]="'Footer'" class="mt-3" />
    <textarea
        id="footer"
        formControlName="footer"
        [required]="isFieldRequired(composeForm, 'footer')"
        rows="3"
        class="form-control"
        [class.is-invalid]="composeForm.get('footer')?.invalid && composeForm.get('footer')?.touched"
        [class.is-valid]="composeForm.get('footer')?.valid && composeForm.get('footer')?.touched">
    </textarea>
    @if (composeForm.get('footer')?.invalid && composeForm.get('footer')?.touched) {
        <div class="error-messages">
            @if (composeForm.get('footer')?.errors?.['required']) {
                <p class="text-danger text-start pt-1 mb-0">{{ FormValidatorMessages.CommunicationsFooterRequired }}</p>
            }
        </div>
    }
</form>
